export enum ReportTypesNamesEnum {
  ImpactSummary = 'Impact Summary Report',
  AchievementSummary = 'Achievement Summary Report',
  StudentGradebook = 'Student Gradebook Report',
  StudentAchievementSummary = 'Student Achievement Report',
}
